/** Provider addresses are looked up this many at a time */
export const ADDRESS_LOOKUP_BATCH_SIZE = 10;

export const UNORDERED_NOTICE =
  "The stops couldn't be ordered from your location.";

export const getSkippedNotice = (skipped: number) =>
  skipped === 1
    ? '1 provider was skipped because it has no address that can be routed.'
    : `${skipped} providers were skipped because they have no address that can be routed.`;
